import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const PromotionRenderStyle = {
  listPromos: css`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    ${media.sm} {
      grid-template-columns: 1fr;
      gap: 6px;
    }
  `,

  empty: css`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 500px;
  `,

  categoryWrapper: css`
    margin-bottom: 20px;
  `,

  banner: css`
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
      border-bottom: solid 20px ${theme.colors.orange[50]};
    }
  `,
  categoryMap: css`
    display: flex;
    justify-content: flex-start;
    margin: 5px 0 15px;
    ${media.md} {
      flex-wrap: wrap;
    }

    .item-cate {
      width: 166px;
      height: 42px;
      padding: 0 5px;
      color: #fff;
      font-size: 15px;
      line-height: 42px;
      background: url("/v2/promotion/promotion_category.png") center top;
      cursor: pointer;
      margin-left: 10px;
      display: inline-block;
      text-align: center;
      &:hover {
        background-position: bottom;
        opacity: 1;
      }
      ${media.md} {
        background: ${theme.colors.orange[50]};
        font-size: 0.75rem;
        line-height: 1rem;
        width: auto;
        height: auto;
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
        margin: 0.25rem;
        margin-left: 0;
        margin-right: 10px;
        border-radius: 0.25rem;
        opacity: 0.6;
      }

      &:nth-of-type(1) {
        margin-left: 0;
      }

      &.selected {
        background-position: bottom;
        opacity: 1;
      }
    }
  `,
};
